import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SearchableSelectModule } from '../../common/searchable-select/searchable-select.module';
import { ListingHeaderComponent } from './listing-header/listing-header.component';
import { ListingFiltersComponent } from './listing-filters/listing-filters.component';
import { ListingPaginationComponent } from './listing-pagination/listing-pagination.component';
import { ListingTableComponent } from './listing-table/listing-table.component';

@NgModule({
  declarations: [
    ListingHeaderComponent,
    ListingFiltersComponent,
    ListingPaginationComponent,
    ListingTableComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    FontAwesomeModule,
    SearchableSelectModule
  ],
  exports: [
    ListingHeaderComponent,
    ListingFiltersComponent,
    ListingPaginationComponent,
    ListingTableComponent
  ]
})
export class ListingModule { }
